import { createRouter as _createRouter, createWebHistory } from 'vue-router'
import Profile from './views/Profile.vue';
import Home from './views/LandingPage.vue';
import About from './views/About.vue';
import Contribute from './views/Contribute.vue';
import Blog from './views/Blog.vue';
import Search from './views/Search.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import TermsAndConditions from './views/TermsAndConditions.vue';
import MyHomes from './components/profile/MyHomes.vue';
import BulkUpload from './components/profile/BulkUpload.vue';
import NoPermissionMessage from './components/NoPermissionMessage.vue';
import AddHome from './views/AddHome.vue';
import SearchDetailWrapper from "@/views/SearchDetailWrapper";
import ProfileSettings from "@/components/profile/ProfileSettings";
import AddBlogPost from '@/components/profile/AddBlogPost.vue';

export function createRouter() { return _createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      redirect: { name: 'yourHomes' },
      children: [
        { name: 'yourHomes', path: 'your-homes', component: MyHomes },
        { name: 'bulkUpload', path: 'bulk-upload', component: BulkUpload },
        { name: 'addBlogPost', path: 'add-blog-post', component: AddBlogPost },
        { name: 'noAccess', path: 'no-access', component: NoPermissionMessage },
        { name: 'settings', path: 'settings', component: ProfileSettings}
      ],
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contribute',
      name: 'contribute',
      component: Contribute,
    },
    {
      path: '/blog/:id?',
      name: 'blog',
      component: Blog,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
    {
      path: '/details/:id',
      name: 'details',
      component: SearchDetailWrapper,
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/add',
      name: 'add',
      component: AddHome
    },
    {
      path: '/terms-conditions',
      name: 'termsAndConditions',
      component: TermsAndConditions,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: PrivacyPolicy,
    }
  ]
})
}